(function($){
    var $window = $(window);
    var navbarMenu;
    var body;
    var navbarToggle;
    var heroSection = null;

    $(document).on( 'ready', startNavbar );
    $(window).on( 'load', startNavbarBgDetection );

    function startNavbar() {
        navbarMenu = $( '#navbar-menu' );
        body = $( 'body' );
        navbarToggle = $('.followme-top-navbar .navbar-toggler' );
        startNavbarToggle();
        startMobileSubMenuToggle();
    }

    function startNavbarToggle() {
        navbarToggle.on( 'click', function() {
            navbarMenu.toggleClass( 'opened' );
            body.toggleClass('is-menu-open');
        });
    }

    function startMobileSubMenuToggle() {
        $(document).on('click', '.menu-item-has-children > span', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            var $span = $(this);
            var $subMenu = $span.siblings('.sub-menu');
            var $parentItem = $span.parent();
            
            $parentItem.toggleClass('active');
            $subMenu.toggleClass('active');
        });
    }

    function startNavbarBgDetection() {
        heroSection = $('.followme-top-hero' );
        var isHero = heroSection.length ? true : false;

        let yOffset = $window.scrollTop();

        if ( yOffset > 0 ) {
            body.addClass( 'followme-scrolled-down' );
        } else {
            body.removeClass( 'followme-scrolled-down' );
        }

        $window.on("scroll", (evt) => {
            let yOffset = $window.scrollTop();

            if ( isHero ) {
                heroHeight = heroSection.height();
                if ( yOffset > 0 && yOffset <= heroHeight ) {
                    body.addClass( 'followme-scrolling-in-hero' );
                } else {
                    body.removeClass( 'followme-scrolling-in-hero' );
                }

                if ( yOffset > 0 && yOffset > heroHeight ) {
                    body.addClass( 'followme-scrolling-past-hero' );
                } else {
                    body.removeClass( 'followme-scrolling-past-hero' );
                }

            }

            if ( yOffset > 0 ) {
                body.addClass( 'followme-scrolled-down' );
            } else {
                body.removeClass( 'followme-scrolled-down' );
            }
        });
    }
})(jQuery);